import { SYNTH_TYPES } from '../config/synth-types';
import { applyEnvelopeSettings } from '../audio/engine';
import * as store from '../state/store';
import { rafThrottle } from './dom';
import { paramLabel } from '../i18n';

/**
 * Per-synth-type parameter sliders. Pushing options onto a PolySynth walks
 * every voice, so updates are coalesced to one per animation frame rather than
 * running on each 'input' tick.
 */
export function createExtraParamsUi(container: HTMLElement): { render: () => void } {
  const pushOptions = rafThrottle(() => applyEnvelopeSettings(store.getSettings()));

  const render = (): void => {
    const s = store.getSettings();
    const type = s.synthType;
    const values = s.extraValues[type] ?? {};
    const frag = document.createDocumentFragment();

    for (const p of SYNTH_TYPES[type].extra) {
      const field = document.createElement('div');
      field.className = 'extra-param-field';

      const value = values[p.key] ?? p.default;
      const name = paramLabel(p.key);
      const label = document.createElement('label');
      const readout = document.createElement('span');
      readout.textContent = p.format ? p.format(value) : String(value);
      label.textContent = `${name}: `;
      label.appendChild(readout);

      const slider = document.createElement('input');
      slider.type = 'range';
      slider.min = String(p.min);
      slider.max = String(p.max);
      slider.step = String(p.step);
      slider.value = String(value);
      slider.setAttribute('aria-label', name);

      slider.addEventListener('input', () => {
        const v = Number(slider.value);
        const bucket = store.get('extraValues')[type];
        if (bucket) bucket[p.key] = v;
        readout.textContent = p.format ? p.format(v) : String(v);
        pushOptions();
        store.touch('extraValues');
      });

      field.append(label, slider);
      frag.appendChild(field);
    }

    container.replaceChildren(frag);
  };

  render();
  return { render };
}
